import { Absolute, Flex as BaseFlex } from 'mds-web-ui'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'
import styled from 'styled-components'
import { border } from 'styled-system'

import { FlowLinks } from '../Flow/FlowLink'
import { Paragraph } from '../utils/Typography'
import { useDesktopBreakpoint } from '../utils/mediaQueries'

export const TryFlow = ({ appIcons, ctaImage, ...props }) => {
  const image = getImage(ctaImage)
  const flowIconImage = getImage(appIcons.flowIconImage)

  const isDesktop = useDesktopBreakpoint()

  return (
    <Flex
      bg="#fff"
      color="#000"
      borderRadius={16}
      justifyContent="flex-end"
      alignItems="center"
      height={[250, 200]}
      flexDirection={['column', 'row']}
      p={[3, 4]}
      gap={[3, 4]}
      {...props}
    >
      <Absolute left={0} top={[0, -20]} width={['98%', 'auto']}>
        <GatsbyImage image={image} alt="Try Flow!" />
      </Absolute>

      {isDesktop ? <Paragraph>Sketch, Draw, Take Notes.</Paragraph> : null}
      <FlowLinks flowIconImage={flowIconImage} />
    </Flex>
  )
}

const Flex = styled(BaseFlex)(
  {
    overflow: 'hidden',
    position: 'relative',
    boxShadow: '0px 15px 40px -3px rgb(0 0 0 / 0.1)'
  },
  border
)
